<template>
  <center><h1>Logging in...</h1></center>
</template>

<script>

export default {

  async mounted() {
    if (this.$route.query.code !== undefined) {
      const enableAnalytics = process.env.VUE_APP_ENABLE_ANALYTICS === 'true';
      const tokenData = this.$route.query.code;
      await this.$store.dispatch('user/getAcessToken', tokenData);
      this.$store.dispatch('user/decodeToken', this.$store.getters['user/accessToken']);
      localStorage.setItem('tokenLoginInformation', this.$store.getters['user/accessToken']);

      // Registar to Application Insights
      if (enableAnalytics) {
        const userData = this.$store.getters['user/userData'];
        this.$insights.trackPageViewWithMetaInfo(userData);
      }

      this.$router.push({ name: 'home' });
      return;
    }

    const result = await this.$store.dispatch('user/doLogin');

    if (result !== undefined) {
      if (result.success) {
        window.location.href = result.url;
        return;
      }
      // TODO: implement error message passed as param
      this.$router.push({ name: 'error' });
    }
  },
};
</script>
